const modalBackdrop = "_modalBackdrop_1g3nn_3";
const modalFooter = "_modalFooter_1g3nn_10";
const modalHeader = "_modalHeader_1g3nn_15";
const modalEntering = "_modalEntering_1g3nn_37";
const modalExiting = "_modalExiting_1g3nn_41";
const styles = {
  modalBackdrop,
  modalFooter,
  modalHeader,
  modalEntering,
  modalExiting
};
export {
  styles as s
};
